import type { ObservationValidationTagProps } from "./observation-validation-tag.type";

import { CalendarOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { Tag } from "@/ui/tag";
import { format } from "@/utilities/date";
import { toEllipsis } from "@/utilities/string";

import "./observation-validation-tag.style.less";

const ObservationValidationTag = ({
  observation,
}: ObservationValidationTagProps) => {
  const { t } = useTranslation();

  if (!observation?.validation) return;

  const { user, date } = observation.validation;
  const shortUserName = toEllipsis(user.name, 16);

  return (
    <Tooltip
      title={
        <span className="observation-validation-tag-tooltip">
          {t("observation:validation.user", { name: user.name })}
          <br />
          {t("observation:validation.date", { date: format(date) })}
        </span>
      }
    >
      <Tag color="success" className="observation-validation-tag">
        <CheckCircleOutlined />
        {t("observation:validation.user", { name: shortUserName })}
        <CalendarOutlined />
      </Tag>
    </Tooltip>
  );
};

export default ObservationValidationTag;
